var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 6.3499999 6.35",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.529167,
      strokeDasharray: "none",
      paintOrder: "stroke markers fill"
    },
    id: "path1",
    cx: 2.3812499,
    cy: 2.3812501,
    r: 1.8520831
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    style: {
      strokeLinecap: "round",
      paintOrder: "stroke markers fill"
    },
    d: "M 4.2968953,3.7930501 C 4.1389531,4.0068897 3.9461973,4.1931493 3.7269043,4.3439209 L 5.3748657,5.992399 c 0.1549231,0.1546053 0.4057662,0.1546053 0.5606893,0 0.1546052,-0.1549231 0.1546052,-0.4057661 0,-0.5606892 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.264584,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke markers fill"
    },
    d: "M 3.4298038,2.3493617 C 3.4306699,2.1046193 3.3447677,1.8674902 3.1873526,1.6800866 2.9622368,1.4128753 2.6174862,1.277298 2.2706565,1.319585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.0c085b27a313a26bb4b4959f52c509fd.svg";
export { ForwardRef as ReactComponent };